import { KeyboardShortcutKey } from '@/components/ui/KeyboardShortcutKey';
import { cx } from '@/cva.config';

const splitShortcut = (keys: string): string[] => {
  if (keys.includes(' ')) {
    return keys.split(/\s+/);
  }

  const match = keys.match(/^([⇧⌃⌘⌥]+)(.*)$/);

  if (!match) {
    return [keys];
  }

  const modifiers = match[1] ?? '';
  const rest = match[2] ?? '';

  return rest ? [modifiers, ...splitShortcut(rest)] : [modifiers];
};

interface ShortcutProps {
  className?: string;
  keys: string | string[];
}

export const Shortcut = ({ keys, className }: ShortcutProps) => {
  const parts = typeof keys === 'string' ? splitShortcut(keys) : keys;

  return (
    <div className={cx('inline-flex gap-0.5', className)}>
      {parts.map((part) => (
        <KeyboardShortcutKey key={part}>{part}</KeyboardShortcutKey>
      ))}
    </div>
  );
};
